import requestFunctions from "../../functions/requestFunctions";

export const state = {
  FILES_ITEM: {},
  FILES_LIST: [],
  FILES_TOTAL_ROWS: 0
}

export const getters = {
  GET_FILES_ITEM: (state) => {
    return state.FILES_ITEM;
  },
  GET_FILES_LIST: (state) => {
    return state.FILES_LIST;
  },
  GET_FILES_TOTAL_ROWS: (state) => {
    return state.FILES_TOTAL_ROWS;
  }
}

export const mutations = {
  UPDATE_FILES_ITEM(state, item) {
    state.FILES_ITEM = item;
  },
  UPDATE_FILES_LIST(state, list) {
    state.FILES_LIST = list.data;
    state.FILES_TOTAL_ROWS = list.total;
    list = list.data;
  },
}

export const actions = {

  async FETCH_FILES_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/informs/files/'+payload.uuid;
    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_FILES_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_FILES_LIST({ commit }, payload = {}) {

    let query_url = 'https://api.client.za-bota.com/v1/files';
    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_FILES_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_FILES_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/files';
    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_FILES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/files/'+payload.uuid;
    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_FILES_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/files/'+payload.uuid;
    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}